import { getExtension, stripExtension } from '../../../utils/file';

type FilenamesCountMap = Record<string, number>;

export class UniqueFilenameManager {
  private readonly filenamesMap!: FilenamesCountMap;

  private constructor(filenamesMap: FilenamesCountMap) {
    this.filenamesMap = filenamesMap;
  }

  public static init(initialMap: FilenamesCountMap = {}) {
    return new UniqueFilenameManager(initialMap);
  }

  public getUniqueFilename(filename: string): string {
    const count = this.filenamesMap[filename] ?? 0;

    this.filenamesMap[filename] = count + 1;

    if (count === 0) {
      return filename;
    }

    const extension = getExtension(filename);
    const filenameWithoutExtension = stripExtension(filename);

    return `${filenameWithoutExtension} (${count})${extension ? `.${extension}` : ''}`;
  }
}
